/**
 * @generated SignedSource<<990a19d612d32ac589f5ceae8a72b642>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type SbRespDesignsComponents_user$data = {
  readonly " $fragmentSpreads": FragmentRefs<"SbRespMainContent_user" | "SbRespNullSearchResults_user" | "SbSharedPageBreadcrumbs_user" | "SbSharedTitle_user" | "SharedFollowTopButton_user" | "SharedSaveSearchContext_user" | "TradePromo_user">;
  readonly " $fragmentType": "SbRespDesignsComponents_user";
};
export type SbRespDesignsComponents_user$key = {
  readonly " $data"?: SbRespDesignsComponents_user$data;
  readonly " $fragmentSpreads": FragmentRefs<"SbRespDesignsComponents_user">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [
    {
      "kind": "RootArgument",
      "name": "isTrade"
    }
  ],
  "kind": "Fragment",
  "metadata": null,
  "name": "SbRespDesignsComponents_user",
  "selections": [
    {
      "condition": "isTrade",
      "kind": "Condition",
      "passingValue": true,
      "selections": [
        {
          "args": null,
          "kind": "FragmentSpread",
          "name": "TradePromo_user"
        }
      ]
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "SbRespNullSearchResults_user"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "SbRespMainContent_user"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "SharedFollowTopButton_user"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "SbSharedTitle_user"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "SbSharedPageBreadcrumbs_user"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "SharedSaveSearchContext_user"
    }
  ],
  "type": "User",
  "abstractKey": null
};

(node as any).hash = "7cc7290a2d6d8f2e6674ea8b9480c04e";

export default node;
